.lanes {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}
